import { setTranslations } from '@99designs/common/apps/global-nav/locale-data';
import Bugsnag from 'common/utils/Bugsnag';
import { addLocaleData } from 'react-intl';

export function loadIntlDataForLocale(locale: string): Promise<void> {
    return new Promise(resolve => {
        const loadData = (...args: any[]) => {
            addLocaleData.apply(null, args);
            resolve();
        };

        switch (locale.slice(0, 2)) {
            case 'de':
                return require(['react-intl/locale-data/de'], loadData);
            case 'en':
                return require(['react-intl/locale-data/en'], loadData);
            case 'es':
                return require(['react-intl/locale-data/es'], loadData);
            case 'nl':
                return require(['react-intl/locale-data/nl'], loadData);
            case 'pt':
                return require(['react-intl/locale-data/pt'], loadData);
            case 'ja':
                return require(['react-intl/locale-data/ja'], loadData);
            case 'fr':
                return require(['react-intl/locale-data/fr'], loadData);
            case 'it':
                return require(['react-intl/locale-data/it'], loadData);
            default:
                Bugsnag.notify({
                    name: 'InvalidLocaleError',
                    message: `Missing data for locale: ${locale}`,
                });
                return require(['react-intl/locale-data/en'], loadData);
        }
    });
}

export function loadGlobalNavIntlDataForLocale(locale: string): Promise<void> {
    return new Promise(resolve => {
        const loadData = (data: { default: any }) => {
            setTranslations(data.default);
            resolve();
        };

        switch (locale.slice(0, 2)) {
            case 'de':
                return require(['@99designs/common/apps/global-nav/locale-data/de'], loadData);
            case 'en':
                return require(['@99designs/common/apps/global-nav/locale-data/en'], loadData);
            case 'es':
                return require(['@99designs/common/apps/global-nav/locale-data/es'], loadData);
            case 'fr':
                return require(['@99designs/common/apps/global-nav/locale-data/fr'], loadData);
            case 'it':
                return require(['@99designs/common/apps/global-nav/locale-data/it'], loadData);
            case 'ja':
                return require(['@99designs/common/apps/global-nav/locale-data/ja'], loadData);
            case 'nl':
                return require(['@99designs/common/apps/global-nav/locale-data/nl'], loadData);
            case 'pt':
                return require(['@99designs/common/apps/global-nav/locale-data/pt'], loadData);
            default:
                Bugsnag.notify({
                    name: 'InvalidLocaleError',
                    message: `Missing data for locale: ${locale}`,
                });
                return require(['@99designs/common/apps/global-nav/locale-data/en'], loadData);
        }
    });
}



// WEBPACK FOOTER //
// ./js/common/utils/intl.ts